/** @jsx jsx */
import { jsx, ThemeUIStyleObject, Text as ThemeUIText } from "theme-ui"
import React from "react"
import { PrimitiveProps } from "@styles/types"

export interface TextProps
  extends PrimitiveProps,
    React.ComponentPropsWithoutRef<"p"> {
  as?: React.ElementType
}

export const textStyles: ThemeUIStyleObject = {
  maxWidth: "100%",
  whiteSpace: "pre-line",
}

const Text: React.FC<TextProps> = ({ as, children, sx, ...props }) => (
  <ThemeUIText as={as} sx={{ ...textStyles, ...sx }} {...props}>
    {children}
  </ThemeUIText>
)

Text.defaultProps = {
  as: "p",
}

export { Text }
